import { render, staticRenderFns } from "./PreChatForm.vue?vue&type=template&id=5766909a&scoped=true&"
import script from "./PreChatForm.vue?vue&type=script&lang=js&"
export * from "./PreChatForm.vue?vue&type=script&lang=js&"
import style0 from "./PreChatForm.vue?vue&type=style&index=0&id=5766909a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5766909a",
  null
  
)

export default component.exports